import { BaseModel, attr, hasMany} from "../../lib/itn-ui-kit/data";

export default class CaseFolderModel extends BaseModel {
    static urlPath = 'folders';

    @attr('string') folderId;
    @attr('string') folderName;
    @attr('string') parentFolderId;
    @attr('array') folders;
    @hasMany('document') documents;
}